import * as React from "react";
import { Button, Export, color } from "@conserveit/blocks";
import { CsvObject, handleCsvExport } from "./utils";

type ButtonType = React.ComponentProps<typeof Button>;

interface Props extends ButtonType {
  rawData: any;
  fileName: string;
  dataFormatter: (rawData: any) => CsvObject;
}

/**
 *
 * Exporter accpets all props from Button,
 *
 * dataFormatter is a custom function as prop that developers create
 * to format the rawData into a format that can be understood by
 * the helper function getCsvBlobUrl from './util'
 * @param props
 *
 */
export const Exporter: React.FC<Props> = (props) => {
  const { rawData, fileName, dataFormatter, children, ...rest } = props;

  return (
    <Button
      thin
      appearance="subdued"
      icon={<Export small fillColor={color.theme.typography.subdued} />}
      onClick={() => handleCsvExport(rawData, fileName, dataFormatter)}
      {...rest}
    >
      {children}
    </Button>
  );
};
